"use client";

import { ContentfulLivePreview } from "@contentful/live-preview";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";

export default function RecipeYieldTime({ recipe }: { recipe: Recipe }) {
  const updateRecipe = useContentfulLiveUpdates(recipe);
  return (
    <div className="flex gap-4 py-2">
      <p>
        <span className="text-gray-500">Time:</span>{" "}
        <span
          className="font-bold"
          {...ContentfulLivePreview.getProps({
            entryId: recipe?.sys.id,
            fieldId: "time",
          })}
        >
          {updateRecipe.time}
        </span>
      </p>
      <p>
        <span className="text-gray-500">Yield:</span>{" "}
        <span
          className="font-bold"
          {...ContentfulLivePreview.getProps({
            entryId: recipe?.sys.id,
            fieldId: "yield",
          })}
        >
          {updateRecipe.yield}
        </span>
      </p>
    </div>
  );
}
